import { FC, PropsWithChildren } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { parseAndFormatQuestionResponse } from 'utils/models/Performance';
import { INPUT_TYPES } from 'views/Widgets/Inputs/ValidatedInputTypes';
import { Person } from '../../../../types';
import { PrivateDataBadge } from '../../components/PrivateDataBadge';
import PersonResponseRow from '../PersonResponseRow';

export type ManagerCommentsProps = PropsWithChildren<{
  author: Person;
  comments?: string;
  isPrivate: boolean;
}>;

export const ManagerComments: FC<ManagerCommentsProps> = ({
  isPrivate,
  ...props
}) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <h6 className="text-uppercase text-secondary mb-3">
        <FormattedMessage
          id="app.views.person.person_performance.trajectory.manager_comments.manager_comments"
          defaultMessage="Manager comments"
        />{' '}
        {isPrivate && <PrivateDataBadge />}
      </h6>
      <PersonResponseRow
        author={props.author}
        text={
          parseAndFormatQuestionResponse({
            q: {
              question: {
                type: INPUT_TYPES.RICH_TEXT_EDITOR,
              },
              response: props.comments,
            },
            formatMessage: formatMessage,
          }) ??
          formatMessage({
            id: 'app.views.person.person_performance.trajectory.manager_comments.no_comments_provided',
            defaultMessage: 'There are no comments you are eligible to view',
          })
        }
        last={true}
      />
    </div>
  );
};
